import { LitElement, html } from 'lit'

class CtaSection extends LitElement {
    // Use open DOM for Tailwind styling
    createRenderRoot() {
        return this
    }

    render() {
        return html`
            <section class="section-padding bg-gradient-to-br from-primary-600 via-primary-700 to-primary-800 dark:from-primary-800 dark:via-primary-900 dark:to-gray-900 relative overflow-hidden">
                <!-- Background decoration -->
                <div class="absolute inset-0 overflow-hidden">
                    <div class="absolute -top-24 -right-24 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>
                    <div class="absolute -bottom-24 -left-24 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
                    <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
                </div>

                <div class="container-custom relative z-10">
                    <div class="text-center max-w-4xl mx-auto">
                        <!-- Heading -->
                        <h2 class="text-4xl md:text-6xl font-bold text-white mb-6">
                            Ready to Transform 
                            <span class="text-blue-200">Your Workflow?</span>
                        </h2>

                        <!-- Description -->
                        <p class="text-xl md:text-2xl text-blue-100 mb-12 leading-relaxed max-w-3xl mx-auto">
                            Join thousands of professionals who have already revolutionized their productivity with JigsAI. 
                            Start your free trial today and experience the future of automation.
                        </p>

                        <!-- CTA Buttons -->
                        <div class="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
                            <sl-button
                                variant="default"
                                size="large"
                                @click="${this.handleStartFreeTrial}"
                                class="cta-primary">
                                <sl-icon slot="prefix" library="fa-solid" name="fa-rocket"></sl-icon>
                                Start Free Trial
                            </sl-button>

                            <sl-button
                                variant="default"
                                size="large"
                                @click="${this.handleScheduleDemo}"
                                class="cta-secondary">
                                <sl-icon slot="prefix" library="fa-solid" name="fa-calendar-days"></sl-icon>
                                Schedule a Demo
                            </sl-button>
                        </div>

                        <!-- Value propositions -->
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
                            <div class="flex flex-col items-center text-center">
                                <div class="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-4">
                                    <sl-icon library="fa-solid" name="fa-circle-check" class="text-2xl text-white"></sl-icon>
                                </div>
                                <h3 class="text-lg font-semibold text-white mb-2">Free 14-Day Trial</h3>
                                <p class="text-blue-100">No credit card required</p>
                            </div>

                            <div class="flex flex-col items-center text-center">
                                <div class="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-4">
                                    <sl-icon library="fa-solid" name="fa-headset" class="text-2xl text-white"></sl-icon>
                                </div>
                                <h3 class="text-lg font-semibold text-white mb-2">Expert Support</h3>
                                <p class="text-blue-100">24/7 customer assistance</p>
                            </div>

                            <div class="flex flex-col items-center text-center">
                                <div class="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-4">
                                    <sl-icon library="fa-solid" name="fa-shield-check" class="text-2xl text-white"></sl-icon>
                                </div>
                                <h3 class="text-lg font-semibold text-white mb-2">Enterprise Security</h3>
                                <p class="text-blue-100">Bank-level encryption</p>
                            </div>
                        </div>

                        <!-- Trust badges -->
                        <div class="border-t border-white/20 pt-8">
                            <p class="text-blue-200 text-sm mb-4 uppercase tracking-wider font-medium">
                                Trusted & Secure
                            </p>
                            <div class="flex flex-wrap justify-center items-center gap-6 opacity-80">
                                <div class="flex items-center space-x-2">
                                    <sl-icon library="fa-solid" name="fa-shield-check" class="text-green-300"></sl-icon>
                                    <span class="text-white text-sm">SOC 2 Compliant</span>
                                </div>
                                <div class="flex items-center space-x-2">
                                    <sl-icon library="fa-solid" name="fa-lock" class="text-green-300"></sl-icon>
                                    <span class="text-white text-sm">GDPR Compliant</span>
                                </div>
                                <div class="flex items-center space-x-2">
                                    <sl-icon library="fa-solid" name="fa-circle-check" class="text-green-300"></sl-icon>
                                    <span class="text-white text-sm">ISO 27001</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Custom styles for buttons in this section -->
                <style>
                    .cta-primary::part(base) {
                        background: rgba(255, 255, 255, 1);
                        color: rgb(37, 99, 235);
                        border: none;
                        font-weight: 600;
                        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
                        transition: all 0.2s ease-in-out;
                    }
                    
                    .cta-primary:hover::part(base) {
                        background: rgba(255, 255, 255, 0.95);
                        transform: translateY(-2px);
                        box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3);
                    }
                    
                    .cta-secondary::part(base) {
                        background: rgba(255, 255, 255, 0.1);
                        color: white;
                        border: 2px solid rgba(255, 255, 255, 0.3);
                        font-weight: 600;
                        backdrop-filter: blur(10px);
                        transition: all 0.2s ease-in-out;
                    }
                    
                    .cta-secondary:hover::part(base) {
                        background: rgba(255, 255, 255, 0.2);
                        border-color: rgba(255, 255, 255, 0.5);
                        transform: translateY(-2px);
                    }
                </style>
            </section>
        `
    }

    handleStartFreeTrial() {
        // Handle free trial signup
        console.log('Start free trial clicked')
        // Could redirect to signup page or open modal
    }

    handleScheduleDemo() {
        // Handle demo scheduling
        console.log('Schedule demo clicked')
        // Could open calendar widget or redirect to booking page
    }
}

customElements.define('cta-section', CtaSection)